import isDocumentHidden from 'lib/isDocumentHidden';
import getTrimmedUrl from 'lib/getTrimmedUrl';
import sessionSelectors from 'selectors/session';
import updateCustomerUrl from 'actions/session/updateCustomerUrl';

/**
 * ensuring that if the widget does not receive a stop event we
 * transition isAgentTyping to false after 15 seconds
 */

export default function checkCustomerUrlUpdated(dispatch, getState) {
  let session = getState().session;
  let trimmedUrl = getTrimmedUrl();
  if (
    !isDocumentHidden() &&
    sessionSelectors.hasActiveSession(session) &&
    session.customerUrl &&
    session.customerUrl != trimmedUrl
  ) {
    dispatch(updateCustomerUrl(trimmedUrl));
  }
}
